import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import FeedbackMenu from './FeedbackMenu';
import PreviousSession from './PreviousSessionMenu';
import SessionFeedback from './SessionFeedback';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';

export function DesktopFeedback() {
	const [activeItem, setActiveItem] = useState<string | null>(null);
	const currentFormInFocus = useSelector((state: RootState) => state.feedbackFormInFocus);
	const navigate = useNavigate();

	if (currentFormInFocus > 1) {
		return <div className="mx-auto w-full md:w-7/8 lg:w-2/3 xl:w-1/2"><SessionFeedback /></div>;
	}

	return (
		<div className="w-full">
			<header className="mx-auto hidden w-full items-center border-b border-gray-200 pb-5 pt-7 md:flex md:w-7/8 lg:w-2/3 xl:w-1/2">
				<button aria-label="Back" className="w-[20.833333%] text-center" onClick={() => navigate('..')} type="button">
					<ArrowLeft className="mx-auto size-6" />
				</button>
				<div className="session-feedback-desktop w-[79.166667%]">Submit Session Feedback</div>
			</header>
			<div className="mx-auto block w-full md:grid md:w-7/8 md:grid-cols-12 lg:w-2/3 xl:w-1/2">
				<div className="px-0 md:col-span-5"><FeedbackMenu activeItem={activeItem} onItemClick={setActiveItem} /></div>
				<div className="px-0 md:col-span-7">
					{activeItem === 'previousSession' && <PreviousSession />}
					{activeItem === 'newSession' && <SessionFeedback />}
				</div>
			</div>
		</div>
	);
}
